import Shipping from '../components/shipping';
import Customizations from './product/customizations';
import setPopupSizes from './product/setSizeGuide';
import setDescriptionTabs from './product/setProductTabs';
import setGallery from './product/setGallery';
import LoadGroupShop from './product/compre_junto_finalizar_abaixo';
// import LoadGroupShop from './product/loadGroupShop';
import setCarousel from '../components/carousel';
//addImports

import { formMasks, formatDate, preSale } from '../components/utilities';
import Zoom from './product/zoom';
import BundleSelection from '../components/bundle';
import LoadFloatingBuy from '../components/loadFloatingBuy';

const Product = {
  mainSlider: {
    element: document.querySelector('[data-main-slider]'),
    swiper: false,
  },
  thumbsSlider: {
    element: document.querySelector('[data-slider-thumbs]'),
    swiper: false,
  },
  sectionProduct: document.querySelector('[data-section-product]'),
  imagesWithoutSkus: [],
  thumbsWithoutSkus: [],
  imagesWithSkus: {},
  thumbsWithSkus: {},

  setImages: function () {
    let initialized = false;
    Product.sectionProduct.addEventListener('vnda:sku-change', (event) => {

      if (!initialized) {
        // Na primeira execução, inicializa a estrutura dos dados do produto
        const mainProdId = window.mainProduct;
        const mainProdObject = window.productVariants[mainProdId];
        const variants = mainProdObject.variants || [];
        let skus = [];
        if (variants) skus = variants.map((variant) => variant.sku);

        // Armazena os slides de imagens com e sem SKU
        Product.setImagesWithSkus(skus);
        Product.setImagesWithoutSkus();

        // Marca como inicializado
        initialized = true;
      }

      Product.updateImages(event.detail.sku);
      window.lazyLoad.init();
    });
  },

  setImagesWithoutSkus: function () {
    const thumbsElement = Product.thumbsSlider.element;
    const mainElement = Product.mainSlider.element;

    if (thumbsElement) Product.thumbsWithoutSkus = thumbsElement.querySelectorAll('[data-without-sku]');

    if (mainElement) Product.imagesWithoutSkus = mainElement.querySelectorAll('[data-without-sku]');
  },

  setImagesWithSkus: function (skus) {
    const thumbsElement = Product.thumbsSlider.element;
    const mainElement = Product.mainSlider.element;

    // Busca todas as imagens marcadas com SKU
    const images = [
      ...thumbsElement.querySelectorAll('[data-with-sku]'),
      ...mainElement.querySelectorAll('[data-with-sku]'),
    ];

    // Separa as imagens dentro por SKU, dentro de Thumbs e Main
    skus.forEach((sku) => {
      Product.imagesWithSkus[sku] = [];
      Product.thumbsWithSkus[sku] = [];

      images.forEach((image) => {
        const imageSkus = image.getAttribute('data-skus').split(',');

        let type = 'main';
        if (image.getAttribute('data-image-thumb') != null) type = 'thumb';

        if (imageSkus.includes(sku)) {
          type == 'main' ? Product.imagesWithSkus[sku].push(image) : Product.thumbsWithSkus[sku].push(image);
        }
      });
    });
  },

  updateImages: function (sku) {
    const thumbs = Product.thumbsSlider.swiper;
    const main = Product.mainSlider.swiper;
    const skuThumbs = Product.thumbsWithSkus[sku];
    const skuImages = Product.imagesWithSkus[sku];

    // Adiciona/Remove imagens do swiper thumbs
    // de acordo com sku selecionado
    thumbs.removeAllSlides();
    thumbs.appendSlide(Product.thumbsWithoutSkus);
    if (skuThumbs) thumbs.appendSlide(skuThumbs);

    // Adiciona/Remove imagens do swiper principal
    // de acordo com sku selecionado
    main.removeAllSlides();
    main.appendSlide(Product.imagesWithoutSkus);
    if (skuImages) main.appendSlide(skuImages);

    // Atualiza o swiper após a remoção/adicão de slides
    thumbs.update();
    main.update();
    main.thumbs.update();

    // Muda para o primeiro slide
    thumbs.slideTo(0);
    main.slideTo(0);
  },

  getPreSale: async function() {
    const element = document.querySelector('[data-pre-sale]');
    const attr = 'data-pre-sale';

    if (!element) return;

    const prodId = element.getAttribute(attr);

    try {
      const presaleData = await preSale(prodId);
      Product.setPreSale(presaleData, element)
    } catch (error) {console.error('Erro ao buscar a pré-venda:', error)}
  },

  setPreSale: function(data, element) {
    if (!data) return;

    const currentDate = new Date();
    const presaleDate = new Date(data.presale_end_at);
  
    if (presaleDate <= currentDate || !element) return; // Não exibe se a data já passou

    const formattedDate = formatDate(presaleDate);
    element.classList.remove('-hidden');

    // Informação abaixo do name-price
    const presaleInfo = element.querySelector('.date');
    if (presaleInfo) presaleInfo.innerHTML = formattedDate;
  },

  init: function () {
    const _this = this;

    setDescriptionTabs()
		setGallery(Product)
		LoadGroupShop.init();
		LoadGroupShop.init();
		setCarousel();
		//calls

    _this.setImages();
    _this.getPreSale();
    Zoom.init(Product.mainSlider);
    Customizations.init();
    BundleSelection.init();
    setPopupSizes();
    Shipping.init();
    formMasks();

    if (window.floatingBuyScript && window.floatingBuyStyle){
      LoadFloatingBuy.init();
    }
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Product.init();
});
